export default "__VITE_ASSET__968fd8ac__"